const projectConfig = {
    frontOffice: 'inActive', // active / inActive
  }
  export default projectConfig 